(function () {
  const zoomRatio = 2;   // Adjust zoom level
  const lensSize = 200;  // Diameter of zoom lens in pixels
  const lensMargin = 60; // px the cursor can stray outside the image edge and still see the lens

  function injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .zoom-modal-overlay {
        position: fixed;
        top: 0; left: 0;
        width: 100vw; height: 100vh;
        background-color: rgba(0, 0, 0, 0.72); /* lighter than before */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        cursor: default;
        overflow: auto;
      }

      .zoom-modal-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: visible;
        cursor: none;
      }

      .zoom-modal-image {
        display: block;
        border-radius: 8px;
        box-shadow: 0 0 20px rgba(0,0,0,0.5);
        cursor: none;
        user-select: none;
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
        /* NOTE: image no longer dims / becomes transparent while zooming */
      }

      /* When zoom is toggled off, restore the normal cursor everywhere */
      .zoom-modal-overlay.zoom-off,
      .zoom-modal-overlay.zoom-off .zoom-modal-container,
      .zoom-modal-overlay.zoom-off .zoom-modal-image {
        cursor: default !important;
      }

      /* ── Realistic glass magnifier lens ── */
      .zoom-lens {
        position: absolute;
        width: ${lensSize}px;
        height: ${lensSize}px;
        border-radius: 50%;
        pointer-events: none;
        background-repeat: no-repeat;
        background-size: cover;
        display: none;
        z-index: 10;
        cursor: none;

        /* Glass rim: bright top edge, darker bottom edge */
        border: 1px solid rgba(255, 255, 255, 0.55);
        box-shadow:
          /* soft drop shadow lifting the lens off the image */
          0 18px 40px rgba(0, 0, 0, 0.45),
          0 6px 14px rgba(0, 0, 0, 0.35),
          /* thin inner rim shading — glass thickness at the edge only */
          inset 0 0 0 2px rgba(255, 255, 255, 0.18),
          inset 0 -6px 12px rgba(0, 0, 0, 0.18),
          inset 0 5px 10px rgba(255, 255, 255, 0.14);
      }

      /* Faint edge tint only at the rim — keeps the glass feel
         without covering the zoomed image */
      .zoom-lens::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: radial-gradient(
          circle at 50% 50%,
          rgba(255, 255, 255, 0) 78%,
          rgba(160, 200, 255, 0.08) 90%,
          rgba(255, 255, 255, 0.14) 100%
        );
        pointer-events: none;
      }

      .zoom-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 48px;
        height: 48px;
        border-radius: 999px;
        border: 2px solid #ffffff;
        background: #000000;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        font-weight: 600;
        cursor: pointer;
        z-index: 20;
        user-select: none;
        box-shadow:
          0 0 0 2px rgba(255, 40, 40, 0.65),
          0 10px 26px rgba(0, 0, 0, 0.9);
        transition:
          background 150ms ease,
          box-shadow 150ms ease,
          transform 130ms ease,
          border-color 150ms ease,
          opacity 150ms ease;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        opacity: 1;
      }

      .zoom-arrow--prev { left: calc(-48px - 32px); }
      .zoom-arrow--next { right: calc(-48px - 32px); }

      .zoom-arrow:hover {
        background: radial-gradient(circle at 30% 30%, #ff4b4b, #ff0000);
        transform: translateY(-50%) scale(1.08);
        box-shadow:
          0 0 0 2px rgba(255, 120, 120, 0.95),
          0 16px 36px rgba(255, 0, 0, 0.65);
        border-color: #ffffff;
      }

      .zoom-arrow:active {
        transform: translateY(-50%) scale(0.95) translateY(1px);
        background: radial-gradient(circle at 30% 30%, #e02020, #7a0000);
        box-shadow:
          0 0 0 2px rgba(255, 110, 110, 0.95),
          0 8px 22px rgba(80, 0, 0, 0.9);
      }

      .zoom-arrow:focus-visible {
        outline: 2px solid rgba(255, 255, 255, 0.95);
        outline-offset: 3px;
      }

      @media (max-width: 768px) {
        .zoom-modal-container {
          cursor: auto;
          padding: 12px;
        }

        .zoom-modal-image {
          cursor: auto;
          max-width: 100%;
          max-height: calc(100vh - 40px);
        }

        .zoom-arrow {
          width: 52px;
          height: 52px;
          font-size: 28px;
        }

        .zoom-arrow--prev { left: 8px; }
        .zoom-arrow--next { right: 8px; }
      }
    `;
    document.head.appendChild(style);
  }

  function getScaledDimensions(imgNaturalWidth, imgNaturalHeight, maxWidth, maxHeight) {
    let width = imgNaturalWidth;
    let height = imgNaturalHeight;

    if (width > maxWidth) {
      const ratio = maxWidth / width;
      width = maxWidth;
      height = height * ratio;
    }

    if (height > maxHeight) {
      const ratio = maxHeight / height;
      height = maxHeight;
      width = width * ratio;
    }

    return { width, height };
  }

  function createZoomModal(imageElement) {
    const imageSrc = imageElement.dataset.zoomSrc || imageElement.src;

    if (document.getElementById('zoom-modal-overlay')) return;

    const overlay = document.createElement('div');
    overlay.className = 'zoom-modal-overlay';
    overlay.id = 'zoom-modal-overlay';

    const container = document.createElement('div');
    container.className = 'zoom-modal-container';

    const zoomedImage = new Image();
    zoomedImage.className = 'zoom-modal-image';
    zoomedImage.src = imageSrc;
    zoomedImage.alt = 'Zoomed Product Image';
    zoomedImage.draggable = false;

    const lens = document.createElement('div');
    lens.className = 'zoom-lens';

    zoomedImage.onload = function () {
      const maxWidth = window.innerWidth * 0.68;
      const maxHeight = window.innerHeight * 0.68;

      const { width, height } = getScaledDimensions(
        zoomedImage.naturalWidth,
        zoomedImage.naturalHeight,
        maxWidth,
        maxHeight
      );

      container.style.width = `${width}px`;
      container.style.height = `${height}px`;
      zoomedImage.style.width = '100%';
      zoomedImage.style.height = '100%';

      container.appendChild(zoomedImage);
      container.appendChild(lens);
      overlay.appendChild(container);
      document.body.appendChild(overlay);

      // Lock scroll
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflowY = 'scroll';

      const galleryImages = Array.from(document.querySelectorAll('.image-magnify-hover'));
      const gallerySources = galleryImages.map(img => img.dataset.zoomSrc || img.src);

      let currentIndex = gallerySources.indexOf(imageSrc);
      if (currentIndex === -1) currentIndex = 0;
      let zoomEnabled = true; 

      const prevBtn = document.createElement('button');
      prevBtn.className = 'zoom-arrow zoom-arrow--prev';
      prevBtn.type = 'button';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.textContent = '‹';

      const nextBtn = document.createElement('button');
      nextBtn.className = 'zoom-arrow zoom-arrow--next';
      nextBtn.type = 'button';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.textContent = '›';

      container.appendChild(prevBtn);
      container.appendChild(nextBtn);

      function showImageAt(index) {
        if (!gallerySources.length) return;
        currentIndex = (index + gallerySources.length) % gallerySources.length;
        const newSrc = gallerySources[currentIndex];
        lens.style.display = 'none';
        zoomedImage.src = newSrc;
      }

      function closeModal() {
        document.removeEventListener('keydown', handleKeyDown);
        // Restore scroll
        const top = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflowY = '';
        window.scrollTo(0, parseInt(top || '0') * -1);
        overlay.remove();
      }

      function handleKeyDown(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showImageAt(currentIndex + 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showImageAt(currentIndex - 1);
        }
      }

      // ── Lens active lensMargin px outside the image edge ──
      function updateLensPosition(clientX, clientY) {
        if (!zoomEnabled) { lens.style.display = 'none'; return; }
        const bounds = zoomedImage.getBoundingClientRect();
        const offsetX = clientX - bounds.left;
        const offsetY = clientY - bounds.top;

        const inZone =
          offsetX >= -lensMargin && offsetX <= bounds.width  + lensMargin &&
          offsetY >= -lensMargin && offsetY <= bounds.height + lensMargin;

        if (!inZone) {
          lens.style.display = 'none';
          return;
        }

        // Scaled image dimensions inside the lens
        const scaledW = bounds.width  * zoomRatio;
        const scaledH = bounds.height * zoomRatio;

        // Where the cursor sits on the scaled image (px from top-left of scaled image)
        const scaledCursorX = offsetX * zoomRatio;
        const scaledCursorY = offsetY * zoomRatio;

        // Shift the background so the cursor point sits at the lens center.
        // Negative because background-position moves the image left/up.
        const bgX = lensSize / 2 - scaledCursorX;
        const bgY = lensSize / 2 - scaledCursorY;

        // Lens circle follows the real cursor (including outside the image)
        lens.style.left = `${offsetX - lensSize / 2}px`;
        lens.style.top  = `${offsetY - lensSize / 2}px`;
        lens.style.backgroundImage    = `url(${zoomedImage.src})`;
        lens.style.backgroundSize     = `${scaledW}px ${scaledH}px`;
        lens.style.backgroundPosition = `${bgX}px ${bgY}px`;
        lens.style.display = 'block';
      }

      overlay.addEventListener('click', (e) => {
  // Click on empty backdrop → close (unchanged behavior)
  if (e.target === overlay) { closeModal(); return; }
  // Click on the image → toggle zoom off/on
  if (e.target === zoomedImage) {
    zoomEnabled = !zoomEnabled;
    overlay.classList.toggle('zoom-off', !zoomEnabled);   // ← shows/hides cursor via CSS
    if (!zoomEnabled) lens.style.display = 'none';
    else updateLensPosition(e.clientX, e.clientY);        // re-show lens under cursor
  }
});

      // Listen on the overlay so the cursor can roam lensMargin px outside
      // the image without the lens disappearing. updateLensPosition hides
      // the lens automatically once the cursor exits the margin zone.
      overlay.addEventListener('mousemove', (e) => {
        updateLensPosition(e.clientX, e.clientY);
      });

      overlay.addEventListener('mouseleave', () => {
        lens.style.display = 'none';
      });

      container.addEventListener('touchstart', (e) => {
        const t = e.touches[0];
        if (!t) return;
        updateLensPosition(t.clientX, t.clientY);
      }, { passive: true });

      container.addEventListener('touchmove', (e) => {
        const t = e.touches[0];
        if (!t) return;
        updateLensPosition(t.clientX, t.clientY);
      }, { passive: true });

      container.addEventListener('touchend', () => {
        lens.style.display = 'none';
      });

      container.addEventListener('touchcancel', () => {
        lens.style.display = 'none';
      });

      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        showImageAt(currentIndex - 1);
      });

      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        showImageAt(currentIndex + 1);
      });

      document.addEventListener('keydown', handleKeyDown);

      zoomedImage.onload = null;
    };
  }

  function enableZoomOnHover() {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach((image) => {
      image.addEventListener('click', (e) => {
        e.preventDefault();
        createZoomModal(image);
      });
    });
  }

  injectStyles();
  enableZoomOnHover();
})();
